"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_pfeil_suedwest = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_pfeil_suedwest = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACuSURBVFhH7ZXhDYIwFIQrEziKIzAKIziCm6iTwAaOwAiMoHelmIZQIJF3/nlfcmnfH76jQAiO4wi4IC1yjpMYygfkjbwQaYlcztwRGS4/TN4gN+Qap3VM7pyfDy/Wx6mM2bHvKWD6zLcKmL9wawXM5aRUQCInSwVkcjIvIJWTvIBcTqYCFMvlZCqQ51D5Ka0lWKAet1+6tJZ4Io9x+ztLJ7AV/jt2U6XVcZw/EcIHJd5miiG17r4AAAAASUVORK5CYII=",
    iconSize: [32, 32],
});
